var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dragging)?_c('div',{attrs:{"id":"upload-overlay-text"}},[_c('div',{staticClass:"mb-2"},[_c('font-awesome-icon',{staticStyle:{"font-size":"4rem"},attrs:{"icon":"fa-regular fa-cloud-arrow-up"}})],1),_c('h3',[_vm._v("Drop files here to upload")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }